export default __webpack_public_path__ + "static/media/submit.df6e5302.ogg";